import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { EventType, type AuthenticationResult } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ThemeProvider } from "@skein/design";
import { ToastProvider } from "@skein/ui";
import { msal } from "../auth/msal";
import { onMsalEvent } from "../auth/loginState";
import { router } from "./router";
import "@skein/design/css";
import "./layout.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

async function boot(): Promise<void> {
  await msal.initialize();
  msal.addEventCallback((e) => {
    onMsalEvent(e);
    if (e.eventType === EventType.LOGIN_SUCCESS && e.payload) msal.setActiveAccount((e.payload as AuthenticationResult).account);
  });
  await msal.handleRedirectPromise();
  const first = msal.getAllAccounts()[0];
  if (!msal.getActiveAccount() && first) msal.setActiveAccount(first);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <MsalProvider instance={msal}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme="taller">
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </MsalProvider>
    </StrictMode>,
  );
}
void boot();
